import { Icon, type IconProps } from "@chakra-ui/react";
import React, { useId } from "react";

export function PeopleIcon(props: IconProps) {
  const clipPathId = useId();
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <g
        clipPath={`url(#${clipPathId}-a)`}
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M14.1666 17.5v-1.6667c0-.884-.3512-1.7319-.9763-2.357-.6251-.6251-1.473-.9763-2.357-.9763H4.16659c-.88406 0-1.73191.3512-2.35703.9763-.62512.6251-.976308 1.473-.976308 2.357V17.5M7.50008 9.16667c1.84095 0 3.33332-1.49239 3.33332-3.33334S9.34103 2.5 7.50008 2.5 4.16675 3.99238 4.16675 5.83333s1.49238 3.33334 3.33333 3.33334ZM19.1667 17.5001v-1.6667c-.0005-.7386-.2463-1.456-.6988-2.0397-.4525-.5838-1.086-1.0007-1.8012-1.1853M13.3333 2.6084c.717.18358 1.3525.60058 1.8063 1.18526.4539.58467.7002 1.30376.7002 2.04391 0 .74014-.2463 1.45923-.7002 2.0439-.4538.58468-1.0893 1.00168-1.8063 1.18526" />
      </g>
      <defs>
        <clipPath id={`${clipPathId}-a`}>
          <rect width="20" height="20" fill="#fff" />
        </clipPath>
      </defs>
    </Icon>
  );
}
